import AveragePayment from './AveragePayment';

export default AveragePayment;
